import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TableIconActive: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='25'
			viewBox='0 0 24 25'
			width='24'
			{...props?.innerSvgProps}
		>
			<path
				d='M18.75 21.5107H5.25C5.05109 21.5107 4.86032 21.4317 4.71967 21.2911C4.57902 21.1504 4.5 20.9597 4.5 20.7607V4.26074C4.5 4.06183 4.57902 3.87106 4.71967 3.73041C4.86032 3.58976 5.05109 3.51074 5.25 3.51074H14.25L19.5 8.76074V20.7607C19.5 20.9597 19.421 21.1504 19.2803 21.2911C19.1397 21.4317 18.9489 21.5107 18.75 21.5107Z'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.25 3.51074V8.76074H19.5'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9 13.2607H15'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9 16.2607H15'
				stroke='white'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default TableIconActive;
